const {
  // API start
  // REACT_APP_API_URL = "http://localhost:3008/webapi/",
  // REACT_APP_BACKEND_URL = "http://localhost:3008/",
  // REACT_APP_SOCKET_URL = "http://localhost:3008/",
  REACT_APP_API_URL = "https://api.coindh.com/webapi/",
  REACT_APP_BACKEND_URL = "https://api.coindh.com/",
  REACT_APP_SOCKET_URL = "https://api.coindh.com/",
  REACT_APP_CAPTCHA_STATUS = "Disable",
  REACT_APP_BANK_PAYMENT_EDIT = "Disable",
  REACT_APP_UPI_PAYMENT_EDIT = "Disable",
  REACT_APP_TRADE_STATUS = "Disable",
  REACT_APP_P2P_STATUS = "Disable",
  REACT_APP_NOTIFICATION_STATUS = "Disable",
  REACT_APP_APIDOC_STATUS = "Disable",
  // API end
  // USDM_API start
  REACT_APP_USDM_API_URL = "http://localhost:3021/webapi/",
  REACT_APP_USDM_BACKEND_URL = "http://localhost:3021/",
  REACT_APP_USDM_SOCKET_URL = "http://localhost:3021/",
  REACT_APP_DERIVATIVES_STATUS = "Disable",
  // USDM_API end
  // Site detail start
  REACT_APP_FRONTEND_URL = "http://localhost:3000",
  REACT_APP_FRONEND_URL_PRINT = "coindh.com",
  REACT_APP_SITENAME = "coindh Exchange",
  REACT_APP_THEME_NAME = "siteTheme",
  // Site detail end
  // Status start
  REACT_APP_NFT_STATUS = "Disable",
  REACT_APP_STAKING_STATUS = "Enable",
  REACT_APP_CONVERT_STATUS = "Disable",
  // Status end
} = process.env;

const KEY = {
  // API start
  V1_API_URL: REACT_APP_API_URL + "v1/",
  V2_API_URL: REACT_APP_API_URL + "v2/",
  BACKEND_URL: REACT_APP_BACKEND_URL,
  SOCKET_URL: REACT_APP_SOCKET_URL,
  CAPTCHA_STATUS: REACT_APP_CAPTCHA_STATUS,
  PAYMENT_BANK_EDIT: REACT_APP_BANK_PAYMENT_EDIT,
  PAYMENT_UPI_EDIT: REACT_APP_UPI_PAYMENT_EDIT,
  TRADE_STATUS: REACT_APP_TRADE_STATUS,
  P2P_STATUS: REACT_APP_P2P_STATUS,
  NOTIFICATION_STATUS: REACT_APP_NOTIFICATION_STATUS,
  APIDOC_STATUS: REACT_APP_APIDOC_STATUS,
  // API end
  // USDM start
  USDM_V1_API_URL: REACT_APP_USDM_API_URL + "v1/",
  USDM_V2_API_URL: REACT_APP_USDM_API_URL + "v2/",
  USDM_BACKEND_URL: REACT_APP_USDM_BACKEND_URL,
  USDM_SOCKET_URL: REACT_APP_USDM_SOCKET_URL,
  DERIVATIVES_STATUS: REACT_APP_DERIVATIVES_STATUS,
  // USDM end
  // Site detail start
  FRONEND_URL: REACT_APP_FRONTEND_URL,
  FRONEND_URL_PRINT: REACT_APP_FRONEND_URL_PRINT,
  SITENAME: REACT_APP_SITENAME,
  // Site detail end
  // Status start
  NFT_STATUS: REACT_APP_NFT_STATUS,
  STAKING_STATUS: REACT_APP_STAKING_STATUS,
  CONVERT_STATUS: REACT_APP_CONVERT_STATUS,
  // Status end
  THEME_NAME: REACT_APP_THEME_NAME,
  whitepaper: "Whitepaper",
  TFA: {
    downLoadLink: {
      googleApp:
        "https://apps.apple.com/us/app/google-authenticator/id388497605",
      playstoreApp:
        "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN&gl=US&pli=1",
    },
  },
  appLinks: {
    googlePlay:
      "https://play.google.com/store/apps/details?id=com.baalds.coindh&hl=en_IN",
    appStore: "comingsoon",
  },
  google: {
    recaptcha: {
      TEST_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
      ROBO_SITE_KEY: "6LeOTbwlAAAAAOPejRjeFefnEfm4GP8gEK4obULq",
      INVI_SITE_KEY: "6LduBL0lAAAAAPS5l10Q4Ds6Kk13gyFlgBLiPRnD",
      V3_SITE_KEY: "6Lc0McAlAAAAAP_rAaTZICanvxoygETlLfuUBbrG",
      SITE_KEY: "6LduBL0lAAAAAPS5l10Q4Ds6Kk13gyFlgBLiPRnD",
    },
  },
  // coinListing: "https://docs.google.com/forms/d/e/1FAIpQLSd5SoG9HchTyDoVUx5rJsJ1d5tBwXPKVhSGMOCWlNbFEEPwgA/viewform",
  coinListing: "-",
  timer: {
    resendOtp: 120,
  },
  nftLink: "",
  stakingLink: "comingsoon",
  // competitionLink: "/comingsoon",
  competitionLink: "/trading-competition",
  FanTknSymbol: "CDH",
  fanTkn: {
    active: "Disable",
    symbol: "CDH",
  },
  depositFiatStatus: "Enable",
};

export default KEY;
